<template>
        <v-card :elevation="1" class="background-2 round-card" width="100%">
            <v-card-title class="pa-3 py-1">
                <v-col cols="auto" class="pa-0">
                    <div class="pl-2 pl-xl-3 subtitle-2">Configurazione Campi {{ $trans(modelDef) }}{{ templateLabel }}</div>
                </v-col>
                <v-col class="pa-0 flex-grow-1">
                    <v-tabs right hide-slider class="tabs-pill" v-model="tab" background-color="background-2">
                        <v-tab :key="1" class="secondary-tab" v-if="form">Form</v-tab>
                        <v-tab :key="2" class="secondary-tab" v-if="table">Tabella</v-tab>
                        <v-tab :key="3" class="secondary-tab" v-if="show">{{ audit ? 'Audit' : 'Dettagli'}}</v-tab>
                        <v-tab :key="4" class="secondary-tab" v-if="customFields">Campi Personalizzati</v-tab>
                        <v-tab v-for="(totalsConfig, index) in totals" :key="'totals-' + index" class="secondary-tab">{{ totalsConfig.label }}</v-tab>
                    </v-tabs>
                </v-col>
            </v-card-title>
            <v-divider></v-divider>

            <v-tabs-items v-model="tab" touchless dense>

                <v-tab-item :key="1" v-if="form">
                    <fields-form-selector :modelDef="modelDef" :templateData="templateData" :info="info"></fields-form-selector>
                </v-tab-item>

                <v-tab-item :key="2" v-if="table">
                    <fields-table-selector :modelDef="modelDef" :templateData="templateData" :info="info"></fields-table-selector>
                </v-tab-item>

                <v-tab-item :key="3" v-if="show">
                    <fields-show-selector :modelDef="modelDef" :templateData="templateData" :info="info" :audit="audit"></fields-show-selector>
                </v-tab-item>

                <v-tab-item :key="4" class="background-1" v-if="customFields">
                    <v-row class="ma-0">
                        <v-col class="pa-0" cols="12">
                            <crud
                                :model-def="'customfields-' + modelDef"
                                action-icon= "settings"
                                :title= "'Campi Personalizzati ' + $trans(modelDef)"
                                :crud-dialog="true"
                                action-position="absolute"
                                card-classes="round-card-b background-2"
                            ></crud>
                        </v-col>
                    </v-row>
                </v-tab-item>

                <v-tab-item v-for="(totalsConfig, index) in totals" :key="'totals-item-' + index">
                    <fields-totals-selector
                        v-if="totalsLoaded"
                        :model-def="modelDef"
                        :all-fields="getTotalsFields(totalsConfig.infoTotals)"
                        :configuration="getTotalsConfiguration(totalsConfig)"
                        :config-key="getConfigKey(totalsConfig)"
                        :roles="roles"
                    ></fields-totals-selector>
                </v-tab-item>
            </v-tabs-items>

        </v-card>
</template>

<script>
    import FieldsFormSelector from '@/components/common/FieldsFormSelector'
    import FieldsShowSelector from '@/components/common/FieldsShowSelector'
    import FieldsTableSelector from '@/components/common/FieldsTableSelector'
    import FieldsTotalsSelector from '@/components/common/FieldsTotalsSelector'

    export default {
        name: 'fields-selector',
        components: {
            FieldsShowSelector,
            FieldsFormSelector,
            FieldsTableSelector,
            FieldsTotalsSelector,
        },

        props: {
            modelDef: {
                type: String,
                required: true
            },
            templateData: {
                type: String,
                default: 'template_data'
            },
            info: {
                type: String,
                default: 'info'
            },
            form: {
                type: Boolean,
                default: true
            },
            table: {
                type: Boolean,
                default: true
            },
            show: {
                type: Boolean,
                default: true
            },
            audit: {
                type: Boolean,
                default: false
            },
            customFields: {
                type: Boolean,
                default: true
            },
            totals: {
                type: Array,
                default: () => []
                // Structure: [{ label: 'Totali Interventi', infoTotals: 'info_totals', configKey: 'fields_totals_configuration_info_totals' }]
            },
        },

        data() {
            return {
                tab: null,
                roles: [],
                totalsFields: {},
                totalsConfigurations: {},
                totalsLoaded: false,
            }
        },

        computed: {
            templateLabel() {
                if (this.templateData !== 'template_data') {
                    // Trasforma template_data_ticket_ddt in " (Ticket DDT)"
                    const label = this.templateData
                        .replace('template_data_', '')
                        .replace(/_/g, ' ')
                        .toUpperCase()
                    return ` (${label})`
                }
                return ''
            }
        },

        methods: {
            async loadTotalsData() {
                if (!this.totals.length) return

                try {
                    const infoTotalsVars = this.totals.map(t => t.infoTotals)

                    const [fieldsResponse, rolesResponse] = await Promise.all([
                        this.axios.post('settings/fields-model/', {
                            model: this.modelDef,
                            template_data: this.templateData,
                            info: this.info,
                            info_totals: infoTotalsVars
                        }),
                        this.axios.post('getoptionfields/', {model: 'Role', relation_field: 'name', key: 'text', value: 'value'})
                    ])

                    this.roles = rolesResponse.data.option_fields
                    this.totalsFields = fieldsResponse.data.totals_fields || {}
                    this.totalsConfigurations = fieldsResponse.data.totals_configurations || {}
                    this.totalsLoaded = true
                } catch (error) {
                    console.error('Error loading totals data:', error)
                }
            },

            getTotalsFields(infoTotals) {
                const totalsData = this.totalsFields[infoTotals]
                return totalsData?.fieldDefs || []
            },

            getTotalsConfiguration(totalsConfig) {
                const configKey = totalsConfig.configKey || `fields_totals_configuration_${totalsConfig.infoTotals}`
                return this.totalsConfigurations[totalsConfig.infoTotals] || null
            },

            getConfigKey(totalsConfig) {
                return totalsConfig.configKey || `fields_totals_configuration_${totalsConfig.infoTotals}`
            }
        },

        mounted() {
            this.$store.commit('endProgress')
            if (this.totals.length) {
                this.loadTotalsData()
            }
        }
    }
</script>

<style>
    .v-tabs-items {
        overflow: visible !important;
    }
</style>
